import { render, staticRenderFns } from "./index.vue?vue&type=template&id=656a21c0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=656a21c0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656a21c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/zippo-mdm-vue-prd/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('656a21c0')) {
      api.createRecord('656a21c0', component.options)
    } else {
      api.reload('656a21c0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=656a21c0&scoped=true", function () {
      api.rerender('656a21c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/data-template/detail/index.vue"
export default component.exports